<script setup>
import FormComponent from "@/components/apply-page/FormComponent.vue";
import TitleComponent from "@/components/apply-page/TitleComponent.vue";
</script>

<template>
	<div class="apply-page">
		<TitleComponent />
		<FormComponent></FormComponent>
	</div>
</template>

<style lang="scss" scoped>
.apply-page {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 0 auto;
	width: 100%;
}
</style>
